<template>
  <!-- 申请列表 -->
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="box">
    </div>
    
    <div class="main">
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%" :cell-style="cellStyle">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="name"  label="用户姓名"></el-table-column>
          <el-table-column prop="password"  label="用户密码"></el-table-column>
          <el-table-column :prop="`time${index}`" v-for="(index,item) in list_title_count" :key="index"  width="160"  :label="getLabel(index)"></el-table-column>
        </el-table>
      </div>
      <el-divider></el-divider>
      <el-button @click="$router.push('/main/live_statistics?room_id='+$route.query.room_id)" type="info" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { viewWhiteList } from "@/api/operating";
import {  deepCopy } from "@u/tools";
export default {
  data() {
    return {
      list: [],
      pages: {}
    };
  },
  methods: {
    // 初始化获取数据
    pullData() {
      this.$showLoading();
      if(!this.$route.query.room_id){
          this.$message('没有直播间ID，请返回重试！');
          return;
      }
      viewWhiteList({
        room_id:this.$route.query.room_id
      }).then(data => {
          if (data.error > 0) {
            this.$message(data.msg);
            return;
          }
          this.list = data.list;
          this.$hideLoading();
        })
        .catch(err => {
          this.$hideLoading();
        });
    },
    
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}
.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.addBtn.on {
  position: absolute;
  left: 30px;
  bottom: 0;
}
.pages {
  text-align: right;
  margin-top: 30px;
}
.box {
  margin-bottom: 20px;
}
.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}
.search-gropu.on {
  flex: 2;
}

.search-child {
  margin-left: 20px;
  width: 150px;
  margin-right: 40px;
}
.userinfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
.box-card {
  margin: 0 15px 15px;
  color: #666;
  span.on {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
.checkBox {
  display: flex;
  align-items: center;
}
.checkBox-title {
  margin-right: 24px;
}
.demo-drawer__footer {
  display: flex;
  justify-content: space-around;
}
</style>
<style lang="scss">
.el-checkbox__label {
  display: flex;
  align-items: center;
}
.el-drawer__body {
  overflow: auto;
}
</style>